export const environment = {
  production: true,
  env: 'staging',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  API_URL: 'https://api.staging.homhero.com.au/',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  PCI_URL: 'https://secure.staging.homhero.com.au/pci',
};
